import { array, mixed } from 'yup';
/** Reflects the structure of values of select fields to be used throughout the app */
export const yupMultiSelectFormat = array(mixed());
export const yupSingleSelectFormat = mixed().nullable();
